import { render, staticRenderFns } from "./PurchaseCanceled.vue?vue&type=template&id=5605280b&"
import script from "./PurchaseCanceled.vue?vue&type=script&lang=js&"
export * from "./PurchaseCanceled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports